
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Calendar } from '../../Calendar/entry';
import { Loader } from '../../index';
import { fetchCalendarEvents } from '../../../actions/calendarEvents';
import { sendTemplateRequest } from '../../../actions/auth';
import calendarEvents from '../../../reducers/calendarEvents';

const propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

const defaultProps = {
  name: 'explorelive',
  type: 'mini',
};

// @todo: make this stateless?
// TODO: convert tockify into a npm package
class CalendarPanel extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
    };
  }


  componentDidMount() {
    const { getEvents } = this.props;
    getEvents();
  }

  render() {

    return (
      <div className={`widget panel calendar position-relative`}>
        {
          (this.props.isFetching) ?
          (<Loader dark fill />) :
          (
            <div id="calendar-carousel">
              <Calendar
                className="mx-auto"
                onChange={(date) => this.setState({ date })}
                value={this.state.date}
                events={this.props.events}
                calendarType="US"
              />
            </div>
          )
        }
      </div>
    );

  }

}

const mapStateToProps = (state) => {
  return {
    isFetching: state.calendarEvents.isFetching,
    events: state.calendarEvents.data || [],
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getEvents: id => dispatch(fetchCalendarEvents()),
  };
};

CalendarPanel.propTypes = propTypes;
CalendarPanel.defaultProps = defaultProps;

export default connect(mapStateToProps, mapDispatchToProps)(CalendarPanel);
